// extracted by mini-css-extract-plugin
export default {"aservice":"Agroen_aservice__aM7HK","aimagenes":"Agroen_aimagenes__JbgBs","abig":"Agroen_abig__z8Spc","alittles":"Agroen_alittles__8gxJ6","atext":"Agroen_atext__pe4Ab"};